import type { SxProps, Theme } from '@mui/material';
import { Link, Typography } from '@mui/material';

import { SUPPORT_EMAIL } from '@/constants/constants';

export const SupportContact = ({ sx }: { sx?: SxProps<Theme> }) => (
  <Typography sx={sx}>
    Any issues? Drop us a line at{' '}
    <Link
      color='text.primary'
      href={`mailto:${SUPPORT_EMAIL}`}
      sx={{ whiteSpace: 'nowrap' }}
      target='_top'
    >
      {SUPPORT_EMAIL}
    </Link>
  </Typography>
);
